import { SplashScreen } from "@capacitor/splash-screen";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { useTranslation } from "@/core/i18n";
import { TextButton } from "atoms/text-button/TextButton";
import { EmptyState } from "molecules/empty-state/EmptyState";
import { readReturnTo } from "modules/messages/links/linkNavigationState";

/**
 * Shown when a link leads somewhere that no longer exists — a removed product, an expired offer, a
 * route the app does not have. Offers Home, and the message the patient came from when the link
 * was opened out of one.
 */
export const LinkUnavailable = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const returnTo = readReturnTo(useLocation().state);

  useEffect(() => {
    SplashScreen.hide();
  }, []);

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center" role="alert">
      <EmptyState
        title={t("linkUnavailable.title")}
        body={t("linkUnavailable.body")}
        buttonText={t("linkUnavailable.goHome")}
        onClick={() => navigate("/home")}
      />
      {returnTo && (
        <TextButton onClick={() => navigate(returnTo)}>
          {t("linkUnavailable.backToMessages")}
        </TextButton>
      )}
    </div>
  );
};
